import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

import {Api} from '@/api/config'

import md5 from 'js-md5'

import env from '@/env'

const check_lock_expire = 3000
let memory_check_lock = 0
let loop_sync_login_interval = 2000 //每隔多久同步一次登录状态

// if (process.env.NODE_ENV !== 'production') {
//   loop_sync_login_interval = 120000 //开发环境减少同步频率, 2分钟一次
// }

// const loop_check_login_interval = 300000 //每隔多久验证一次登录用户信息, 5分钟
// const loop_check_login_lock_name = "lock.check_login"
// const lock_ttl = 5000

const state = {
  status: '',
  token: '',
  user: {},
  nonce: {}
}

const getters = {
  is_login: (state, getters, rootState) => {
    return state.user.nickname != null
  }
}

const mutations = {
  nonce_request(state) {
    state.nonce = {
      status: 'loading'
    }
  },
  nonce_success(state, data) {
    state.nonce = {
      status: 'success',
      data: data
    }
  },
  nonce_error(state) {
    state.nonce = {
      status: 'error'
    }
  },
  auth_request(state) {
    state.status = 'loading'
  },
  auth_success(state, data) {
    try {
      localStorage.setItem('token', data.token)
    } catch (e) {
      // console.log('localStorage removeItem auth_success', e)
    }
    mutations.sync_local_storage(state)

    state.user = data.user

    state.status = 'success'
  },
  auth_error(state) {

    // mutations.logout(state) //接口出错不再退登

    state.status = 'error'
  },
  logout(state) {

    try {
      localStorage.setItem('token')
    } catch (e) {
      // console.log('localStorage removeItem logout', e)
    }
    mutations.sync_local_storage(state)

    state.user = {}
    state.status = ''
  },
  sync_local_storage(state) {
    try {
      let newToken = localStorage.getItem('token') || ''

      if (state.token != newToken) {
        state.token = newToken
      }
    } catch (e) {
      // console.log('localStorage sync_local_storage', e)
    }
  },
  sync_login(state) {

    mutations.sync_local_storage(state)

    var app = env.app
    if (!app) {
      return
    }

    //如果处于退登状态，跳转到登录页
    if (!state.token) {

      const login_path = "http://user.pentaq.com/login"
      // const login_path = "/login"

      let requireLogin = app.$route.matched.some(record => record.meta.requireLogin)
      if (!requireLogin) {
        return
      }

      let url = encodeURIComponent(location.href)
      window.location.href = login_path + '?url=' + url

      return
    }
  }
}

mutations.sync_local_storage(state)

const actions = {
  async login({commit, state, dispatch}, params) {
    await dispatch('get_nonce')
    return new Promise((resolve, reject) => {

      commit('auth_request')

      let loginApi = Api.login
      let nonce = state.nonce.data

      let mpass = md5.hex(params.password)
      let pass = md5.hex(nonce + mpass)

      // login: this.name,
      // pass: pass,
      // nonce: nonce
      let loginParams = new FormData()
      loginParams.append('login', params.account)
      loginParams.append('pass', pass)
      loginParams.append('nonce', nonce)

      axios.post(loginApi, loginParams).then(response => {

        let respData = response.data

        if (respData.code != 0) {
          let msg = "登录失败, 账号或密码错误！"
          if (respData.code == -14) {
            msg = '账号权限过期'
          }
          resolve({
            success: false,
            msg: msg
          })
          // console.log('sss')
          // var app = env.app
          // app.$alert("登录失败, 账号或密码错误！", {
          //   confirmButtonText: '确定'
          // })
          return
        }

        let token = respData.data.access_token

        try {
          localStorage.setItem('token', token)
        } catch (e) {
          // console.log('localStorage login', e)
        }

        commit('sync_local_storage')

        dispatch('check_login').then(isSuccess => {
          if (!isSuccess) {
            return
          }

          resolve({
            success: true
          })
        })

      }).catch((error) => {

        commit("auth_error")

        throw(error)
      })
    })
  },
  logout({commit, state}) {
    return new Promise((resolve, reject) => {
      // 后端登出
      let logoutApi = Api.logout

      let params = {
        access_token: state.token
      }

      // console.log(111)

      axios.get(logoutApi, {params: params}).then(response => {

        let respData = response.data

        if (respData.code != 0) {
          resolve({
            success: false,
            msg: "登出失败, 账号或密码错误！"
          })
          return
        }

        resolve({
          success: true
        })

      }).catch((error) => {
        console.log(error)
      })

      try {
        localStorage.removeItem('token')
      } catch (e) {
        // console.log('localStorage removeItem logout', e)
      }

      commit('logout')
      resolve({
        success: true
      })
    })
  },
  get_nonce({commit, state}) {
    return new Promise((resolve, reject) => {
      commit("nonce_request")
      let getNonce = Api.get_a_nonce
      axios.get(getNonce).then(response => {

        let respData = response.data

        if (respData.code != 0) {
          resolve({
            success: false,
            msg: respData.msg || "登录失败"
          })
          return
        }

        commit('nonce_success', respData.data.nonce)
        resolve({
          success: true
        })

      }).catch((error) => {
        commit("nonce_error")
        throw(error)
      })
    })
  },
  check_login({commit, state}) {

    return new Promise((resolve, reject) => {

      if (!state.token) {

        commit("logout")

        resolve(false)
        return
      }

      let thisTime = new Date().getTime()
      let lockTime = memory_check_lock
      let lockPass = !(lockTime > 0) || thisTime < lockTime || thisTime - lockTime > check_lock_expire

      if (!lockPass) {
        return
      }

      memory_check_lock = thisTime

      let userInfoApi = Api.get_level

      let params = new FormData()
      params.append('access_token', state.token)

      axios.post(userInfoApi, params).then((response) => {
        var respData = response.data
        if (respData.code == 200) {

          let retUser = respData.data

          let user = {
            // level: 1,
            // tool: 1,
            nickname: retUser.display_name || null,
          }


          commit('auth_success', {
            token: state.token,
            user: user
          })

          resolve(true)
        } else {

          commit('logout')

          resolve(false)
        }

        memory_check_lock = 0
      }).catch((error) => {

        commit("auth_error")

        throw(error)
      })
    })
  },
  loop_sync_login({commit, state, dispatch}) {

    window.setInterval(function () {
      commit("sync_login")

    }, loop_sync_login_interval)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js